// extracted by mini-css-extract-plugin
export default {"skeleton":"RYzPg","loading":"HEwPA","container":"YV2UQ","link":"Usg4d","dealLabel":"bYp0B","image":"koNJl","closeButton":"G9vDy","closeIcon":"ZRsZ4"};